import { renderTimeViewClock } from "@mui/x-date-pickers";

export const timePickerViewRenderers = {
  hours: renderTimeViewClock,
  minutes: renderTimeViewClock,
  seconds: renderTimeViewClock,
};
